import React, { lazy } from 'react';

const Main = lazy(() => import('pages/Main/Main'));
const Feedback = lazy(() => import('pages/Feedback/Feedback'));
const Offer = lazy(() => import('pages/Offer/Offer'));
const User = lazy(() => import('pages/User/User'));
const NotFound = lazy(() => import('pages/NotFound/NotFound'));

export enum PublicPath {
    main = '/',
    user = '/user/:uuid',
    offer = '/oferta',
    feedback = '/feedback',
    other = '*',
}

export const publicRoutes = [
    {
        path: PublicPath.main,
        page: <Main />,
    },
    {
        path: PublicPath.user,
        page: <User />,
    },
    {
        path: PublicPath.feedback,
        page: <Feedback />,
    },
    {
        path: PublicPath.offer,
        page: <Offer />,
    },
    {
        path: PublicPath.other,
        page: <NotFound />,
    },
];
